import emailjs from '@emailjs/browser';

// Initialize EmailJS with public key
const publicKey = process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY!;
const serviceId = process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID!;
const templateId = process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID!;

console.log('EmailJS Configuration:', {
  hasPublicKey: !!publicKey,
  hasServiceId: !!serviceId,
  hasTemplateId: !!templateId
});

emailjs.init(publicKey);

type FormType = 'contact_form' | 'android_waitlist' | 'detox_challenge';

interface EmailParams {
  [key: string]: unknown;  // Add index signature to allow any string key
  from_name: string;
  reply_to: string;
  subject: string;
  message: string;
  type?: FormType;
}

export const sendEmail = async (params: EmailParams): Promise<{ success: boolean; response?: unknown; error?: unknown }> => {
  try {
    // For waitlist + detox capture, we only want to send the email address
    let emailParams: EmailParams = params
    if (params.type === 'android_waitlist') {
      emailParams = {
        reply_to: params.reply_to,
        from_name: params.from_name || '',
        subject: 'Android Waitlist Signup',
        message: `New signup for Android waitlist: ${params.reply_to}${params.from_name ? ` (${params.from_name})` : ''}`,
        type: params.type,
      }
    } else if (params.type === 'detox_challenge') {
      emailParams = {
        reply_to: params.reply_to,
        from_name: params.from_name || '',
        subject: '7-Day Microplastic Detox Challenge Signup',
        message: `New signup for 7-day detox challenge: ${params.reply_to}${params.from_name ? ` (${params.from_name})` : ''}`,
        type: params.type,
      }
    }

    console.log('Sending email with params:', {
      ...emailParams,
      serviceId,
      templateId,
      type: params.type
    });
    
    const response = await emailjs.send(
      serviceId,
      templateId,
      emailParams
    );
    
    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Email send failed:', error);
    console.error('Error details:', {
      hasPublicKey: !!publicKey,
      hasServiceId: !!serviceId,
      hasTemplateId: !!templateId,
      error
    });
    return { success: false, error };
  }
}; 